export default class TrackChangesIntegration {
  constructor(editor) {
    this.editor = editor;
  }

  init() {
    const editor = this.editor;

    if (
      !editor.plugins.has("CommentsRepository") ||
      !editor.plugins.has("TrackChanges") ||
      !editor.plugins.has("Users")
    )
      return;

    const usersPlugin = editor.plugins.get("Users");

    // Load the users data.
    const collaboration = editor.config.get("collaboration");
    if (!collaboration || !Object.keys(collaboration).length) return;

    const {
      comments = [],
      suggestions = [],
      userId,
      users = [],
    } = collaboration;
    users.map((user) => usersPlugin.addUser(user));

    // Set the current user.
    if (userId) usersPlugin.defineMe(userId);

    // Load the comments data.
    const commentsRepositoryPlugin = editor.plugins.get("CommentsRepository");
    comments.map(
      (comment) =>
        commentsRepositoryPlugin.hasCommentThread(comment.threadId) ||
        commentsRepositoryPlugin.addCommentThread(comment),
    );

    // Load the suggestions data.
    const trackChangesPlugin = editor.plugins.get("TrackChanges");
    suggestions.map((suggestion) =>
      trackChangesPlugin.addSuggestion(suggestion),
    );

    // In order to load comments added to suggestions, you
    // should also configure the comments integration.
  }
}
